export const user = {
    name: 'Iron Hack',
    email: 'ironhack@teste.com',
    imageUrl:
        'https://thispersondoesnotexist.com/image',
}